/** Shared POS sale audit action codes (safe for client + server). */
export const POS_SALE_AUDIT_ACTIONS = {
  CHECKOUT: "POS.SALE.CHECKOUT",
  HOLD_CREATED: "POS.SALE.HOLD_CREATED",
  HOLD_CONFIRMED: "POS.SALE.HOLD_CONFIRMED",
  HOLD_ABANDONED: "POS.SALE.HOLD_ABANDONED",
  PAYMENT_ADDED: "POS.SALE.PAYMENT_ADDED",
  VOIDED: "POS.SALE.VOIDED",
  REFUNDED: "POS.SALE.REFUNDED",
  RETURNED: "POS.SALE.RETURNED",
  EXCHANGED: "POS.SALE.EXCHANGED",
} as const;
